import { makeStyles } from 'tss-react/mui';

export const useProductGalleryEmptyStateStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(4),
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'row',
      gap: theme.spacing(3),
      height: 112,
    },
    [theme.breakpoints.down('sm')]: {
      height: 152,
    },
  },
  icon: {
    strokeWidth: 1,
    flexShrink: 0,
    width: 64,
    height: 64,
    color: theme.palette.text.disabled,
    [theme.breakpoints.down('lg')]: {
      width: 32,
      height: 32,
    },
  },
}));
